import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { color, space, width, height } from 'styled-system';
// @ts-ignore
import AvatarComponent from './avatar.s.svg';
import { BoxStyleProps } from '../Box';

const StyledAvatar = styled(AvatarComponent)`
  vertical-align: middle;
  position: relative;
  ${color};
  ${space};
  ${width};
  ${height};
`;

type AvatarProps = BoxStyleProps &
  Pick<React.SVGProps<SVGSVGElement>, 'preserveAspectRatio' | 'viewBox'>;

const Avatar = ({ viewBox = '0 0 56 56', ...props }: AvatarProps) => (
  <StyledAvatar viewBox={viewBox} {...props} />
);

Avatar.propTypes = {
  color: PropTypes.string.isRequired,
  viewBox: PropTypes.string,
};
Avatar.displayName = 'Avatar';

export default Avatar;
